import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Group } from "../../../types/apiKey";
import { fetchUserGroups } from "../../thunks/group/group.thunks";

interface StateWithGroup {
  group: IGroupState;
}

interface IGroupState {
  groups: Group[];
  loading: boolean;
  error: boolean;
  errorMsg: string | null;
}

const initialState: IGroupState = {
  groups: [],
  loading: false,
  error: false,
  errorMsg: null,
};

const groupSlice = createSlice({
  name: "group",
  initialState,
  reducers: {
    resetGroupState: (state) => {
      state.groups = [];
      state.loading = false;
      state.error = false;
      state.errorMsg = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserGroups.pending, (state) => {
        state.loading = true;
        state.error = false;
        state.errorMsg = null;
      })
      .addCase(
        fetchUserGroups.fulfilled,
        (state, action: PayloadAction<{ groups: Group[] }>) => {
          state.loading = false;
          state.groups = action.payload.groups || [];
        }
      )
      .addCase(fetchUserGroups.rejected, (state, action) => {
        state.loading = false;
        state.error = true;
        state.errorMsg = action.payload || "Failed to fetch groups";
      });
  },
});

export const { resetGroupState } = groupSlice.actions;

export const selectGroups = (state: StateWithGroup) => state.group.groups;
export const selectGroupsLoading = (state: StateWithGroup) =>
  state.group.loading;
export const selectGroupsError = (state: StateWithGroup) => state.group.error;

export default groupSlice.reducer;
